import {Component, Vue} from 'vue-property-decorator'

import Userpic from '@/components/userpic/index.vue';
import user_module from '@/modules/user';

@Component({
    components: {
      Userpic
    }
})

export default class Topmenu extends Vue {

  pages: any[] = [
    // {
    //   name: 'events',
    //   route: '/events',
    //   caption: 'Our events'
    // },
    {
      name: 'about',
      route: '/about',
      caption: 'About us'
    },
    {
      name: 'investingcounterpoint',
      route: '/investing_counterpoint',
      caption: 'Investing Counterpoint'
    },    
    {
      name: 'video_guide',
      route: '/video_guide',
      caption: 'Video Guide'
    },

  ]
            
  get currentRouteName() {
    return this.$route.name;
  }

  get isLogin(){

    return user_module.token || localStorage.getItem('AppToken');
  }

  get route(){

    return this.$route.name;
  }

  get landing(){
    return this.$route.meta.landing ? 'landing' : '';
  }
  
  openNoti(){

    user_module.toggleNoti(true);
  }

    
}